export const subStepListContainerStyles = {
  gap: '2px',
};

export const listItemStyles = {
  paddingLeft: '8px',
  position: 'relative',
  '&::before': {
    content: '"\\2022"',
    position: 'absolute',
    left: 0,
  },
};
